import { createContext } from 'use-context-selector'
import { LoginContextType } from './types'
export const LoginContext = createContext({} as LoginContextType)
